import { gql } from "@apollo/client";

const GET_ALL_RISK_SCORES = gql`
  query getAllRiskScores(
    $sortDirection: SortDirection
    $createdFrom: Date
    $createdTo: Date
    $sortBy: RiskScoreSortBy
    $onlyWithManualRiskScoreAdjustment: Boolean
    $riskScoreClasses: [RiskScoreClass]
    $skip: Int
    $take: Int
  ) {
    riskScores(
      sortDirection: $sortDirection
      createdFrom: $createdFrom
      createdTo: $createdTo
      sortBy: $sortBy
      onlyWithManualRiskScoreAdjustment: $onlyWithManualRiskScoreAdjustment
      riskScoreClasses: $riskScoreClasses
      skip: $skip
      take: $take
    ) {
      totalCount
      items {
        id
        totalScore

        client {
          name
          id
        }

        created
        manualRiskScore {
          id
          scoreModifier
        }
        rules {
          id
          description
          dominantRule
          type
          score
          title
          ruleResult
        }
      }
    }
  }
`;

export default GET_ALL_RISK_SCORES;
